import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import YouTube from 'react-youtube';
import { Layout } from '.';
import { InlineSVG } from '../components';
import LazyImage from '../components/LazyImage/LazyImage';

const formatVideoDuration = duration => {
  const date = new Date(0);
  date.setSeconds(duration);
  return date.toISOString().substr(11,8);
}

@inject('CourseStore') @observer
class Lesson extends Component {
  render() {
    const { CourseStore, item } = this.props;
    const selected = CourseStore.currentLesson.id === item.id;
    const disabled = CourseStore.course.course_enrollment && CourseStore.course.course_enrollment.current_lesson_id && (selected || (item.id > CourseStore.course.course_enrollment.current_lesson_id));
    const style = {
      opacity: (selected || !disabled) ? 1 : 0.5,
      backgroundColor: selected ? '#F4F4F4' : '#FFF'
    };

    return (
      <li style={style}>
        <Link style={{ pointerEvents: disabled ? 'none' : 'auto' }} disabled={disabled} to="#" onClick={() => {
          CourseStore.selectLesson(item.id)
        }}>
          <div>
            <LazyImage src={`https://img.youtube.com/vi/${item.video}/mqdefault.jpg`} alt=""/>
            <InlineSVG src={require('../img/icon-play-course.svg')} />
          </div>
          <section>
            <strong>{item.title}</strong>
            <span><InlineSVG src={require('../img/icon-clock.svg')} />{formatVideoDuration(item.duration)}</span>
          </section>
        </Link>
      </li>
    )
  }

}

@inject('CourseStore') @observer
export default class CourseDetail extends Component{
  componentWillMount() {
		const { CourseStore } = this.props;
		const { params } = this.props.match;

    if (params && params.slug) {
      CourseStore.selectCourse(params.slug);
    }
		window.scrollTo(0,0);
	}

  componentWillUnmount() {
    const { CourseStore } = this.props;
    CourseStore.fetch();
  }

  render() {
    const { CourseStore } = this.props;
    const { course, currentLesson } = CourseStore;

    const opts = {
      
      playerVars: {
        rel: 0,
        modestbranding: 1,
        showinfo: 0,
        autoplay: 1
      },
    };

    const onEnd = (event) => {
      const { CourseStore } = this.props;
      CourseStore.nextLesson();
    }

    const onReady = (event) => {
      // access to player in all event handlers via event.target
      //event.target.pauseVideo();
    }

    return (
      <Layout footerStyle={{backgroundColor: '#FFF'}}>
        <div>
          <section className="main novidades">
          { course && (
            <section className="curso">
              <Link className="return-button" to="/cursos"><InlineSVG src={require('../img/icon-arrow-left-green.svg')} />Voltar</Link>
              <h1>{course.title}</h1>
              
              <div className="player-aulas">
                <div className="player-wrapper">
                { currentLesson && (
                  <YouTube 
                    videoId={currentLesson.video} 
                    opts={opts} 
                    onReady={onReady}
                    onEnd={onEnd} />
                )}
                </div>
                <div className="aulas-list">
                  <ul className="custom-vertical-scrollbar">
                  {course.course_lessons.map(lesson => (
                    <Lesson key={`lesson-${lesson.id}`} item={lesson} />
                  ))}
                  </ul>
                </div>
              </div>
              <div className="curso-infos">

              { currentLesson && (
                <div className="description">
                  <div className="title-wrapper">
                    <h2>{currentLesson.title}</h2>
                  </div>
                  <p>{currentLesson.description}</p>
                </div>
              )}

              { course.course_files.length > 0 && (
                <div className="download-content">
                  <strong>Material de apoio</strong>
                  <ul>
                  { course.course_files.map(file => (
                    <li key={`course_file${file.id}`}>
                      <a href={`/uploads/${file.file_name}`} target="_blank">
                        <InlineSVG src={require('../img/icon-pdf.svg')} /> 
                        <p>{file.title}</p>
                        <img src={require('../img/icon-download-archive.svg')} alt=""/>
                      </a>
                    </li>
                  ))}
                  </ul>
                </div>
              )}
              </div>
            </section>
          )}
          </section>
        </div>
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/CourseDetail.js